import "./Portfolio.module.css";
import Header from "@/reusable_sections/Header";
import GalerADeXitos from "./sections/GalerADeXitos";
import ProyectosDestacados from "./sections/ProyectosDestacados";
import Footer from "@/reusable_sections/Footer";
export default function PortfolioPage() {
  return <div>
      <Header />
      <GalerADeXitos />
      <ProyectosDestacados />
      <Footer />
    </div>;
}